import "Services/I18nService";
import "Services/MediaQueryService";
import "Services/CookieService";
import "Services/GoogleTagManager";
import "../components";

export class App {
  constructor() {
    this.registerServiceWorker();
  }

  async registerServiceWorker() {
    const swPath = document.querySelector<HTMLMetaElement>('meta[name="sw-path"')?.content;
    if ("serviceWorker" in navigator && swPath) {
      try {
        // broaden the scope of sw if it is not accessible in root folder but has the `Service-Worker-Allowed` header
        await navigator.serviceWorker.register(swPath, { scope: "/" });
      } catch (error) {
        console.log("Service worker registration failed:", error);
      }
    }
  }
}
